
export const heatmap = ["rgb(0, 3, 255)", "rgb(0, 9, 255)", "rgb(0, 15, 255)", "rgb(0, 22, 255)",
    "rgb(0, 28, 255)", "rgb(0, 34, 255)", "rgb(0, 40, 255)", "rgb(0, 47, 255)",
    "rgb(0, 53, 255)", "rgb(0, 59, 255)", "rgb(0, 65, 255)", "rgb(0, 72, 255)",
    "rgb(0, 78, 255)", "rgb(0, 84, 255)", "rgb(0, 90, 255)", "rgb(0, 97, 255)",
    "rgb(0, 103, 255)", "rgb(0, 109, 255)", "rgb(0, 115, 255)", "rgb(0, 122, 255)",
    "rgb(0, 128, 255)", "rgb(0, 134, 255)", "rgb(0, 140, 255)", "rgb(0, 147, 255)",
    "rgb(0, 153, 255)", "rgb(0, 159, 255)", "rgb(0, 165, 255)", "rgb(0, 172, 255)",
    "rgb(0, 178, 255)", "rgb(0, 184, 255)", "rgb(0, 190, 255)", "rgb(0, 197, 255)",
    "rgb(0, 203, 255)", "rgb(0, 209, 255)", "rgb(0, 215, 255)", "rgb(0, 222, 255)",
    "rgb(0, 228, 255)", "rgb(0, 234, 255)", "rgb(0, 240, 255)", "rgb(0, 247, 255)",
    "rgb(0, 253, 255)", "rgb(0, 255, 251)", "rgb(0, 255, 245)", "rgb(0, 255, 239)",
    "rgb(0, 255, 233)", "rgb(0, 255, 227)", "rgb(0, 255, 221)", "rgb(0, 255, 215)",
    "rgb(0, 255, 209)", "rgb(0, 255, 204)", "rgb(0, 255, 197)", "rgb(0, 255, 192)",
    "rgb(0, 255, 186)", "rgb(0, 255, 180)", "rgb(0, 255, 174)", "rgb(0, 255, 168)",
    "rgb(0, 255, 162)", "rgb(0, 255, 157)", "rgb(0, 255, 150)", "rgb(0, 255, 145)",
    "rgb(0, 255, 139)", "rgb(0, 255, 133)", "rgb(0, 255, 127)", "rgb(0, 255, 121)",
    "rgb(0, 255, 115)", "rgb(0, 255, 109)", "rgb(0, 255, 103)", "rgb(0, 255, 98)",
    "rgb(0, 255, 92)", "rgb(0, 255, 86)", "rgb(0, 255, 80)", "rgb(0, 255, 74)",
    "rgb(0, 255, 68)", "rgb(0, 255, 62)", "rgb(0, 255, 56)", "rgb(0, 255, 51)",
    "rgb(0, 255, 45)", "rgb(0, 255, 39)", "rgb(0, 255, 33)", "rgb(0, 255, 27)",
    "rgb(0, 255, 21)", "rgb(0, 255, 15)", "rgb(0, 255, 9)", "rgb(0, 255, 4)",
    "rgb(2, 255, 0)", "rgb(8, 255, 0)", "rgb(13, 255, 0)", "rgb(20, 255, 0)",
    "rgb(25, 255, 0)", "rgb(31, 255, 0)", "rgb(37, 255, 0)", "rgb(43, 255, 0)",
    "rgb(49, 255, 0)", "rgb(55, 255, 0)", "rgb(60, 255, 0)", "rgb(67, 255, 0)",
    "rgb(72, 255, 0)", "rgb(78, 255, 0)", "rgb(84, 255, 0)", "rgb(90, 255, 0)",
    "rgb(96, 255, 0)", "rgb(102, 255, 0)", "rgb(108, 255, 0)", "rgb(114, 255, 0)",
    "rgb(119, 255, 0)", "rgb(125, 255, 0)", "rgb(131, 255, 0)", "rgb(137, 255, 0)",
    "rgb(143, 255, 0)", "rgb(149, 255, 0)", "rgb(155, 255, 0)", "rgb(161, 255, 0)",
    "rgb(166, 255, 0)", "rgb(172, 255, 0)", "rgb(178, 255, 0)", "rgb(184, 255, 0)",
    "rgb(190, 255, 0)", "rgb(196, 255, 0)", "rgb(202, 255, 0)", "rgb(208, 255, 0)",
    "rgb(213, 255, 0)", "rgb(219, 255, 0)", "rgb(225, 255, 0)", "rgb(231, 255, 0)",
    "rgb(237, 255, 0)", "rgb(243, 255, 0)", "rgb(249, 255, 0)", "rgb(255, 255, 0)",
    "rgb(255, 248, 0)", "rgb(255, 242, 0)", "rgb(255, 236, 0)", "rgb(255, 230, 0)",
    "rgb(255, 223, 0)", "rgb(255, 217, 0)", "rgb(255, 211, 0)", "rgb(255, 205, 0)",
    "rgb(255, 198, 0)", "rgb(255, 192, 0)", "rgb(255, 186, 0)", "rgb(255, 180, 0)",
    "rgb(255, 173, 0)", "rgb(255, 167, 0)", "rgb(255, 161, 0)", "rgb(255, 155, 0)",
    "rgb(255, 148, 0)", "rgb(255, 142, 0)", "rgb(255, 136, 0)", "rgb(255, 130, 0)",
    "rgb(255, 123, 0)", "rgb(255, 117, 0)", "rgb(255, 111, 0)", "rgb(255, 105, 0)",
    "rgb(255, 98, 0)", "rgb(255, 92, 0)", "rgb(255, 86, 0)", "rgb(255, 80, 0)",
    "rgb(255, 73, 0)", "rgb(255, 67, 0)", "rgb(255, 61, 0)", "rgb(255, 55, 0)",
    "rgb(255, 48, 0)", "rgb(255, 42, 0)", "rgb(255, 36, 0)", "rgb(255, 30, 0)",
    "rgb(255, 23, 0)", "rgb(255, 17, 0)", "rgb(255, 11, 0)", "rgb(255, 5, 0)",
    "rgb(254, 0, 0)", "rgb(251, 0, 3)", "rgb(248, 0, 6)", "rgb(245, 0, 9)",
    "rgb(242, 0, 12)", "rgb(240, 0, 15)", "rgb(236, 0, 18)", "rgb(234, 0, 21)",
    "rgb(230, 0, 24)", "rgb(228, 0, 27)", "rgb(225, 0, 30)", "rgb(222, 0, 33)",
    "rgb(219, 0, 36)", "rgb(216, 0, 39)", "rgb(213, 0, 42)", "rgb(210, 0, 45)",
    "rgb(207, 0, 47)", "rgb(204, 0, 51)", "rgb(201, 0, 53)", "rgb(199, 0, 57)",
    "rgb(195, 0, 59)", "rgb(193, 0, 62)", "rgb(190, 0, 65)", "rgb(187, 0, 68)",
    "rgb(184, 0, 71)", "rgb(181, 0, 74)", "rgb(178, 0, 77)", "rgb(175, 0, 80)",
    "rgb(172, 0, 83)", "rgb(169, 0, 86)", "rgb(166, 0, 89)", "rgb(163, 0, 92)",
    "rgb(160, 0, 95)", "rgb(157, 0, 98)", "rgb(154, 0, 101)", "rgb(152, 0, 104)",
    "rgb(148, 0, 106)", "rgb(146, 0, 110)", "rgb(143, 0, 112)", "rgb(140, 0, 116)",
    "rgb(137, 0, 118)", "rgb(134, 0, 121)", "rgb(131, 0, 124)", "rgb(128, 0, 127)",
    "rgb(130, 0, 130)", "rgb(133, 0, 133)", "rgb(136, 0, 136)", "rgb(139, 0, 139)",
    "rgb(142, 0, 142)", "rgb(145, 0, 145)", "rgb(148, 0, 148)", "rgb(151, 0, 151)",
    "rgb(153, 0, 153)", "rgb(157, 0, 157)", "rgb(159, 0, 159)", "rgb(163, 0, 163)",
    "rgb(165, 0, 165)", "rgb(168, 0, 168)", "rgb(171, 0, 171)", "rgb(174, 0, 174)",
    "rgb(177, 0, 177)", "rgb(180, 0, 180)", "rgb(183, 0, 183)", "rgb(186, 0, 186)",
    "rgb(189, 0, 189)", "rgb(192, 0, 192)", "rgb(195, 0, 195)", "rgb(198, 0, 198)",
    "rgb(200, 0, 200)", "rgb(204, 0, 204)", "rgb(206, 0, 206)", "rgb(209, 0, 209)",
    "rgb(212, 0, 212)", "rgb(215, 0, 215)", "rgb(218, 0, 218)", "rgb(221, 0, 221)",
    "rgb(224, 0, 224)", "rgb(227, 0, 227)", "rgb(230, 0, 230)", "rgb(233, 0, 233)",
    "rgb(235, 0, 235)", "rgb(239, 0, 239)", "rgb(241, 0, 241)", "rgb(245, 0, 245)",
    "rgb(247, 0, 247)", "rgb(250, 0, 250)", "rgb(253, 0, 253)"];

export const chartcolors = [
    "#2f7ed8",
    "#0d233a",
    "#8bbc21",
    "#910000",
    "#1aadce",
    "#492970",
    "#f28f43",
    "#77a1e5",
    "#c42525",
    "#a6c96a"
]

export const chartgroupmentcolors = [
    "#C7C4FF",
    "#D6EBFF",
    "#CEFFE5",
    "#E8FFD8",
    "#FFEEC4",
    "#FFC4AA",
    "#FFB5C6",
]
